import { Account, TradingAccountDetails, TradingAccountSubmissionData } from '@/common/types'
import { H2 } from '@/common/ui/h2'
import { InfoIconTooltip } from '@/common/ui/tooltip'
import { ACCOUNT_TYPE_LABELS } from '@/locales/en'

type AccountDetailsProps = {
    account: Account | null
    tradingAccount: TradingAccountDetails
}

export const AccountDetails = ({ tradingAccount, account }: AccountDetailsProps) => {
    const AccountDetailsItem = ({ title, info, tooltip }: { title: string; info: string; tooltip?: string }) => (
        <li className="border-b py-4 xs:grid xs:grid-cols-[220px_1fr_100px] xs:min-h-16 xs:place-content-center">
            <div className="font-bold flex items-center">
                {title}
                {tooltip && (
                    <div className="ml-1">
                        <InfoIconTooltip>
                            <p>{tooltip}</p>
                        </InfoIconTooltip>
                    </div>
                )}
            </div>
            <div className="hidden xs:flex items-center">{info}</div>
        </li>
    )
    if (!tradingAccount) return null
    const submissionData = JSON.parse(tradingAccount.submissionData) as TradingAccountSubmissionData
    const accountName =
        account?.accountName ??
        `${submissionData.firstName} ${submissionData.middleName ? `${submissionData.middleName} ` : ``}${submissionData.lastName}`
    return (
        <>
            <H2 className="mt-5">Account details</H2>
            <ul className="mt-2 mb-16">
                <AccountDetailsItem title="Account Name" info={accountName} />
                <AccountDetailsItem
                    title="Account Type"
                    info={account?.accountType ? ACCOUNT_TYPE_LABELS[account.accountType] : 'Individual'}
                />
                <AccountDetailsItem title="Account Number" info={tradingAccount.accountNumber} />
                <AccountDetailsItem
                    title="HIN"
                    info={tradingAccount?.hin ?? ''}
                    tooltip="Your HIN (Holder Identification Number) is a unique identifier for your trading account. Keep it secure and reference it when needed."
                />
            </ul>
        </>
    )
}
